import * as PIXI from "pixi.js";

const ButtonTextureCache = () => {
  const cacheTextures = {};
  const cacheRects = {};

  const getKey = ({color, width, height}) => `${color}:${width}:${height}`;

  const getRect = (data) => {
    const createRect = ({color, width, height}) => {
      const rect = new PIXI.Graphics()
      rect.lineStyle(3, 0xffffff, 1);
      rect.beginFill(color, 0.7)
      rect.drawRoundedRect(0, 0, width, height, 10)
      rect.endFill()
      rect.name = `Rect: ${getKey(data)}`;
      return rect
    }

    return cacheRects[getKey(data)] || (cacheRects[getKey(data)] = createRect(data));
  }

  const getButtonTexture = (data) => {
    const renderer = window.app.renderer;
    const getTexture = (data) => renderer.generateTexture(getRect(data));

    return cacheTextures[getKey(data)] || (cacheTextures[getKey(data)] = getTexture(data))
  }

  return {
    getButtonTexture
  }
}

const buttonTextureCache = new ButtonTextureCache();

export {buttonTextureCache};
